import {
  ChevronRightOutlined,
  FeedOutlined,
  SubdirectoryArrowRight,
  UndoOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import { isEmpty, isEqual, isNil, size } from "lodash";
import { Suspense, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FlxGrid from "../../../../../_src_shared/components/layout/FlxGrid";
import EditableDataRow from "../../../../../components/common/EditableDataRow";
import ProgressStepper, {
  SubStatusProgressStepper,
} from "../../../../../components/common/ProgressStepper";
import OverviewItem from "../../../../../components/data/OverviewItem";
import SelectInput from "../../../../../components/inputs/SelectInput";
import Flx from "../../../../../components/layout/Flx";
import ScreenContent from "../../../../../components/layout/ScreenContent";
import LoadingFallback from "../../../../../components/LoadingFallback";
import Txt from "../../../../../components/typography/Txt";
import TitledCard from "../../../../../components/ui/TitledCard";
import { selectOptionsInterestCalcType } from "../../../../../constants/selectOptions/selectOptionsInterestCalcType";
import {
  loanSubStatusOptionsMap,
  selectOptionsLoanStatus,
} from "../../../../../constants/selectOptions/selectOptionsLoanStatus";
import { useUnderwritingHook } from "../../../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../../../redux/actions/loanDrilldownActions";
import { loanPipelineSet } from "../../../../../redux/actions/loanPipelineActions";

const SummaryTabSummaryCard = ({ baseUrl }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const users = useSelector((state) => state.users);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateLoanData } = useUnderwritingHook();

  return (
    <>
      <TitledCard
        title={"Summary"}
        icon={<FeedOutlined />}
        variant="h3"
        headerSx={{ pt: 2 }}
        headerEndContent={
          <Flx gap={4} ac>
            {/* <OverviewItem
              label={"Created On:"}
              value={`${loanDrilldown?.createDateTime}`}
              type={"date"}
              // endContent={`(${getDaysAgo(loanDrilldown?.createDateTime)} days ago)`}
              // stacked
              stacked={false}
            />
            <OverviewItem
              label={"Expected Closing Date:"}
              value={loanDrilldown?.expectedClosingDate}
              // endContent={
              //   getDaysUntil(loanDrilldown?.expectedClosingDate) <= 0
              //     ? null
              //     : `(In ${getDaysUntil(loanDrilldown?.expectedClosingDate)} ${getDaysUntil(loanDrilldown?.expectedClosingDate) === 1 ? "day" : "days"})`
              // }
              type={"date"}
              // stacked
              stacked={false}
            /> */}
            <Flx ac g={2}>
              <LoanStatusSelector />
              {/* <LoanStatusField /> */}
              {/* <LoanSubStatusField /> */}
            </Flx>
          </Flx>
        }
      >
        <Suspense fallback={<LoadingFallback />}>
          <ScreenContent suppressPadding>
            <Flx column gap={5.5}>
              <Flx
                column
                fw
                gap={3}
                sx={{
                  background: "#fafafaa8",
                  border: "1px solid #e5e7eb",
                  borderRadius: "12px",
                  p: "4px",
                  pt: "4px",
                }}
              >
                <LoanProgressStepper />
                <FlxGrid
                  width="180px"
                  gap={3}
                  fw
                  wrap
                  sx={{
                    p: 2,
                    pt: 0,
                  }}
                >
                  <OverviewItem
                    label={"Expected Closing Date:"}
                    value={loanDrilldown?.expectedClosingDate}
                    type={"date"}
                  />
                  <OverviewItem
                    label={"Created On:"}
                    value={`${loanDrilldown?.createDateTime}`}
                    type={"date"}
                  />
                  {/* <OverviewItem
                    label="External Sync ID"
                    labelTooltip="Base Loan To As Is Value"
                    value={loanDrilldown?.sync_loan_id}
                  /> */}

                  {/* <OverviewItem
                    label={"Last Updated:"}
                    // value={loanDrilldown?.updateDatetime}
                    // type={"date"}
                    customValue={`${formatDateTime(loanDrilldown?.updateDatetime)} by ${getUserFullNameFromEmail(users, loanDrilldown?.updateBy)}`}
                  /> */}
                  <OverviewItem
                    label={"Last Updated:"}
                    value={loanDrilldown?.updateDatetime}
                    type={"dateTime"}
                  />
                  <OverviewItem
                    label={"Last Updated By:"}
                    value={loanDrilldown?.updateBy}
                    type={"user"}
                  />
                  <OverviewItem
                    label="Base Loan Amount"
                    value={loanDrilldown?.baseLoanAmount}
                    type={"dollar"}
                  />
                  <OverviewItem
                    label="Base Loan To As Is Value"
                    value={loanDrilldown?.baseLoanToAsIsValue}
                    type={"percent"}
                  />

                  <OverviewItem
                    label="Base Loan To Cost"
                    value={loanDrilldown?.baseLoanToCost}
                    type={"percent"}
                  />

                  <OverviewItem
                    label="Base Loan To Purchase Price"
                    value={loanDrilldown?.baseLoanToPurchasePrice}
                    type={"percent"}
                  />
                  <OverviewItem
                    label="Discount Points"
                    value={loanDrilldown?.discountPoints}
                  />
                  <OverviewItem
                    label="Origination Points"
                    value={loanDrilldown?.originationPoints}
                  />
                  <OverviewItem
                    label="Repeat Borrowers"
                    value={
                      size(
                        loanDrilldown?.borrowers?.filter(
                          (b) => b?.repeatBorrowerFlag,
                        ),
                      ) > 0
                        ? "Yes"
                        : "No"
                    }
                    labelTooltip={
                      isEmpty(
                        loanDrilldown?.borrowers?.filter(
                          (b) => b?.repeatBorrowerFlag,
                        ),
                      )
                        ? 0
                        : loanDrilldown?.borrowers
                            ?.filter((b) => b?.repeatBorrowerFlag)
                            ?.map((b) => `${b.firstName} ${b.lastName}`)
                            .join(", ")
                    }
                  />
                </FlxGrid>
              </Flx>

              {/* <FlxGrid width="340px" gap={8} sx={{ px: 3 }}>
                <TitledGroup
                  title={"Overview"}
                  variant="h5"
                  headerSx={{ p: 0 }}
                  sx={editingSectionItemStyles}
                  bodySx={editingSectionItemBodyStyles}
                  fontWeight={800}
                  suppressPadding
                >
                  <RffLoanDataGroup column initialValues={loanDrilldown}>
                    <EditableDataRow
                      // cellValueSize={5}
                      name="pipeline"
                      label="Pipeline"
                      type="select"
                      options={selectOptionsPipelineType}
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />
                    <EditableDataRow
                      // cellValueSize={5}
                      name="loanProductType"
                      label="Loan Product Type"
                      type="select"
                      options={selectOptionsLoanProductType}
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />
                    <EditableDataRow
                      // cellValueSize={5}
                      name="loanPurpose"
                      label="Loan Purpose"
                      type="select"
                      options={selectOptionsLoanPurpose}
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />
                    <EditableDataRow
                      // cellValueSize={5}
                      name="expectedClosingDate"
                      label="Expected Closing Date"
                      type="date"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />
                  </RffLoanDataGroup>
                </TitledGroup>
                <TitledGroup
                  title={"Terms"}
                  variant="h5"
                  fontWeight={800}
                  headerSx={{ p: 0 }}
                  sx={editingSectionItemStyles}
                  bodySx={editingSectionItemBodyStyles}
                  suppressPadding
                >
                  <RffLoanDataGroup column>
                    <EditableDataRow
                      // cellValueSize={4}
                      name="baseLoanAmount"
                      label="Base Loan Amount"
                      type="dollar"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />

                    <TermsRenderer
                      // cellValueSize={4}
                      // cellValueSize={cellValueSize}
                      onUpdateFn={handleUpdateField}
                    />
                  </RffLoanDataGroup>
                </TitledGroup>

                <TitledGroup
                  title={"Assignee's"}
                  variant="h5"
                  fontWeight={800}
                  headerSx={{ p: 0 }}
                  sx={editingSectionItemStyles}
                  bodySx={editingSectionItemBodyStyles}
                  suppressPadding
                >
                  <RffLoanDataGroup column initialValues={loanDrilldown}>
                    <EditableDataRow
                      // cellValueSize={5}
                      placeholder="—"
                      name="salesperson"
                      label="Salesperson"
                      type="selectUserEmail"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />

                    <EditableDataRow
                      // cellValueSize={5}
                      placeholder="—"
                      name="processor"
                      label="Processor"
                      type="selectUserEmail"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />

                    <EditableDataRow
                      // cellValueSize={5}
                      placeholder="—"
                      name="underwriter"
                      label="Underwriter"
                      type="selectUserEmail"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />

                    <EditableDataRow
                      // cellValueSize={5}
                      placeholder="—"
                      // name="closer"
                      name="loanCloser"
                      label="Closer"
                      type="selectUserEmail"
                      onUpdateFn={handleUpdateField}
                      data={loanDrilldown}
                    />
                  </RffLoanDataGroup>
                </TitledGroup>
              </FlxGrid> */}
              {/* <Flx end fw>
                <Button
                  variant="text"
                  onClick={() => navigate(`${baseUrl}/loan-information`)}
                  endIcon={<EastRounded className="thin" />}
                >
                  Go to Loan Information
                </Button>
              </Flx> */}
            </Flx>
          </ScreenContent>
        </Suspense>
      </TitledCard>
    </>
  );
};

const LoanStatusSelector = ({ sx }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const dispatch = useDispatch();
  const { loading, updateLoanStatusOrSubStatus } = useUnderwritingHook();
  const [loanStatus, setLoanStatus] = useState(null);
  const [subStatus, setSubStatus] = useState(null);

  const subStatusOptions = useMemo(
    () => loanSubStatusOptionsMap[loanStatus] || [],
    [loanStatus],
  );

  const subStatusRequired = !isEmpty(subStatusOptions);
  const subStatusMissing = subStatusRequired && !subStatus;

  const isModified = useMemo(
    () =>
      loanStatus !== loanDrilldown?.loanStatus ||
      subStatus !== loanDrilldown?.subStatus,
    [loanStatus, subStatus, loanDrilldown],
  );

  const handleLoanStatusChange = useCallback((newStatus) => {
    setLoanStatus(newStatus);
    setSubStatus(null);
  }, []);

  const handleUndo = useCallback(() => {
    setLoanStatus(loanDrilldown?.loanStatus);
    setSubStatus(loanDrilldown?.subStatus);
  }, [loanDrilldown]);

  const handleOnSave = useCallback(() => {
    updateLoanStatusOrSubStatus({
      loanId: loanDrilldown?._id,
      loanStatus,
      subStatus,
      onSuccessFn: (res) => {
        dispatch(loanDrilldownSet(res));
        dispatch(loanPipelineSet(null));
      },
      onFailFn: () => {
        setLoanStatus(loanDrilldown?.loanStatus);
        setSubStatus(loanDrilldown?.subStatus);
        dispatch(loanDrilldownSet(loanDrilldown));
      },
    });
  }, [
    loanDrilldown,
    loanStatus,
    subStatus,
    dispatch,
    updateLoanStatusOrSubStatus,
  ]);

  useEffect(() => {
    setLoanStatus(loanDrilldown?.loanStatus);
    setSubStatus(loanDrilldown?.subStatus);
  }, [loanDrilldown]);

  return (
    <Flx
      ac
      gap={1}
      sx={{
        ".MuiSelect-select": {
          fontSize: "12px",
          padding: "6px 8px",
        },
        ...sx,
      }}
    >
      <Flx ac g={0.5}>
        <Txt sx={{ flexShrink: 0 }} secondary>
          Loan Status
        </Txt>
        <SelectInput
          value={loanStatus}
          onChange={handleLoanStatusChange}
          options={selectOptionsLoanStatus}
        />
      </Flx>

      {subStatusRequired && (
        <>
          <ChevronRightOutlined
            sx={{ fontSize: "16px", color: "text.secondary" }}
          />
          <Flx ac g={0.5}>
            <Txt sx={{ flexShrink: 0 }} secondary>
              Sub-Status
            </Txt>
            <SelectInput
              value={subStatus}
              onChange={setSubStatus}
              placeholder="Select sub status"
              options={subStatusOptions}
            />
          </Flx>
        </>
      )}

      {isModified && (
        <Flx ac g={0.5}>
          <Button
            size="small"
            color="error"
            variant="outlined"
            onClick={handleUndo}
            disabled={loading}
          >
            Cancel
          </Button>
          <Tooltip title={subStatusMissing ? "Please select a sub status" : ""}>
            <span>
              <Button
                size="small"
                onClick={handleOnSave}
                loading={loading}
                // disabled={subStatusMissing}
              >
                Update
              </Button>
            </span>
          </Tooltip>
        </Flx>
      )}
    </Flx>
  );
};

// ─── Status Configuration ────────────────────────────────────────────────────

// ─── Status Configuration ────────────────────────────────────────────────────

const STATUS_SEQUENTIAL_PROGRESS = [
  "Terms Accepted",
  "Processing",
  "Underwriting",
  "Condition Clearance",
  "Final Review",
  "Clear To Close",
];

const LOAN_SUBSTATUS_MAP = {
  Processing: ["Appraisal Ordered", "Appraisal In", "Pre-Underwrite"],
  "Clear To Close": ["Docs Out", "Docs Back"],
  Closed: ["Funded with Post Close Conditions", "Funded"],
};

// Reverse lookup: sub-status value → parent status
const SUBSTATUS_TO_PARENT = Object.entries(LOAN_SUBSTATUS_MAP).reduce(
  (acc, [parent, subs]) => {
    subs.forEach((sub) => {
      acc[sub] = parent;
    });
    return acc;
  },
  {},
);

const FINAL_STATUS_OPTIONS = ["Closed", "Inactive", "Dead"];
const SUCCESS_FINAL_STATUSES = ["Closed"];

// ─── Component ───────────────────────────────────────────────────────────────

const LoanProgressStepper = () => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);

  const currentLoanStatus = loanDrilldown?.loanStatus;
  const currentSubStatus = loanDrilldown?.subStatus;

  const { renderedStatusList, activeStep, variant, subStepConfig } =
    useMemo(() => {
      // The loanStatus might itself be a sub-status stored directly
      // (e.g. "Docs Out" for Clear To Close), so check the reverse map.
      let effectiveParent = currentLoanStatus;
      const mappedParent = SUBSTATUS_TO_PARENT[currentLoanStatus];
      if (mappedParent) {
        effectiveParent = mappedParent;
      }

      // ── Final status? ──
      const statusIsFinal = FINAL_STATUS_OPTIONS.includes(effectiveParent);
      const statusIsSuccess = SUCCESS_FINAL_STATUSES.includes(effectiveParent);

      // ── Build status list ──
      let statusList = [...STATUS_SEQUENTIAL_PROGRESS];
      if (statusIsFinal) {
        statusList.push(effectiveParent);
      }

      // ── Variant ──
      let computedVariant = null;
      if (statusIsSuccess) {
        computedVariant = "success";
      } else if (statusIsFinal) {
        computedVariant = "error";
      }

      // ── Active step ──
      const stepIndex = statusList.indexOf(effectiveParent);

      // ── Sub-step config for the active parent ──
      const parentSubStatuses = LOAN_SUBSTATUS_MAP[effectiveParent] || null;
      let config = null;

      if (parentSubStatuses && stepIndex >= 0) {
        // Determine which sub-status is active:
        // 1. Check the dedicated subStatus field
        // 2. Check if loanStatus itself is a sub-status (e.g. "Docs Out")
        const effectiveSubStatus =
          currentSubStatus && parentSubStatuses.includes(currentSubStatus)
            ? currentSubStatus
            : parentSubStatuses.includes(currentLoanStatus)
              ? currentLoanStatus
              : null;

        const subStepIndex = effectiveSubStatus
          ? parentSubStatuses.indexOf(effectiveSubStatus)
          : -1;

        // Only show sub-steps if the loan actually has a sub-status set
        if (subStepIndex >= 0) {
          config = {
            [effectiveParent]: {
              subStatuses: parentSubStatuses,
              activeSubStep: subStepIndex,
            },
          };
        }
      }

      return {
        renderedStatusList: statusList,
        activeStep: stepIndex,
        variant: computedVariant,
        subStepConfig: config,
      };
    }, [currentLoanStatus, currentSubStatus]);

  return (
    <Suspense fallback={<LoadingFallback linear />}>
      <ProgressStepper
        activeStep={activeStep}
        variant={variant}
        statusList={renderedStatusList}
        subStepConfig={subStepConfig}
      />
    </Suspense>
  );
};

// const LoanStatusField = ({ sx }) => {
//   const loanDrilldown = useSelector((state) => state.loanDrilldown);
//   const dispatch = useDispatch();
//   const { loading, updateMilestoneStatus } = useUnderwritingHook();
//   const [status, setStatus] = useState(null);

//   const handleUpdateLoanStatus = useCallback(
//     (newStatus) => {
//       const oldStatus = loanDrilldown?.loanStatus;

//       if (isEqual(newStatus, oldStatus)) return;
//       setStatus(newStatus);

//       updateMilestoneStatus({
//         loanId: loanDrilldown?._id,
//         loanStatus: newStatus,
//         onSuccessFn: (res) => {
//           dispatch(loanDrilldownSet(res));
//           dispatch(loanPipelineSet(null));
//         },
//         onFailFn: () => {
//           setStatus(oldStatus);
//           dispatch(loanDrilldownSet(loanDrilldown));
//         },
//       });
//     },
//     [loanDrilldown, dispatch, updateMilestoneStatus],
//   );

//   useEffect(() => {
//     setStatus(loanDrilldown?.loanStatus);
//   }, [loanDrilldown]);

//   return (
//     <Flx
//       ac
//       gap={4}
//       sx={{
//         // mx: 2,
//         ".MuiSelect-select": {
//           fontSize: "12px",
//           padding: "6px 8px",
//         },
//         ...sx,
//       }}
//     >
//       <Flx ac g={0.65}>
//         <Txt secondary>Status</Txt>
//         <Box
//           sx={{
//             position: "relative",
//             width: status === "Closed w/ Post Closing Conditions" ? 220 : 140,
//           }}
//         >
//           <Suspense fallback={<LoadingFallback />}>
//             <SelectInput
//               value={status}
//               onChange={handleUpdateLoanStatus}
//               options={selectOptionsLoanStatus}
//             />
//           </Suspense>
//           {loading && (
//             <LinearProgress
//               sx={{
//                 position: "absolute",
//                 left: "0px",
//                 bottom: "0px",
//                 borderRadius: "2px",
//                 width: "100%",
//               }}
//             />
//           )}
//         </Box>
//       </Flx>
//     </Flx>
//   );
// };

export default SummaryTabSummaryCard;
